export const domain = window.location.protocol + '//' + window.location.host + "";

export const HOME ="/home";
export const FRIENDS ="/friends";
export const BET ="/bet";
export const MEMBER ="/member";
export const WALLET ="/wallet";
export const DAILY_REWARD ="/daily-rewards";
export const SHOP_DOGS ="/shop-dogs";
export const HISTORY="/history";
export const LOGIN="/LOGIN";
export const CREATE_TOKEN="/create-token";
export const COMPETITION="/competition";
export const PROFILE="/profile";
export const REFERRAL="/referral";
export const AIRDROP="/airdrop";
